import { MSSSpinOffStatus } from '@lib/types';

export const SpinOffMessage = (props: { spinOffStatus: MSSSpinOffStatus | undefined }) => {
  switch (props.spinOffStatus) {
    case MSSSpinOffStatus.SPIN_OFF: {
      return (
        <>
          This member <strong>won't be renewed</strong> because they've reached the maximum age for a dependent.
        </>
      );
    }
    case MSSSpinOffStatus.SPIN_UP: {
      return (
        <>
          This member will be <strong>updated to an adult associate</strong> at renewal because they've reached the
          maximum age for a dependent.
        </>
      );
    }
    default: {
      return <></>;
    }
  }
};
